require('./env')
require('./bootstrap');

import {createApp} from "vue";
import App from "./App.vue";
import { createPinia, PiniaVuePlugin } from 'pinia'
import router from './router';
import mitt from 'mitt';

const emitter = mitt();

const pinia = createPinia()
const app = createApp({
    components: {
        App,
    },
});
app.config.globalProperties.emitter = emitter;
app.use(PiniaVuePlugin);
app.use(router);
app.mount("#app");


